import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {requestCandidates} from '@app/services/CandidateService';
import {capitalizeName} from "@app/utils/CommonUtils";
import MailTemplateList from "@pages/email/template/list/MailTemplateList";
import {MailTempType} from "@pages/email/common/Constant";
import {AcquireCddTabs} from "@pages/email/template/dvtjcuv/DVTJCUVTemplateListManager";
import {DVTJCUVSearchCddJobParentTabs} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import {DVTJCUVConnectCddEmpParentTabs} from "@pages/dvtjcuv/common/ConnectCddEmpTabs";
import ConnectCddEmpContent from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/ConnectCddEmpContent";
import DVTJCUVSearchCddJobContent from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobContent";
import {requestSearchCddJobOverview} from "@pages/dvtjcuv/service/DVTJCUVService";
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import DVTJCUVSearchCddJobOverviewContent
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobOverviewContent";

const DVTJCUVSearchCddJobOverviewModal = (props) => {
    const [overviews, setOverviews] = useState([]);

    const {cddId, isShow, onClose} = props

    const fetchOverview = async () => {
        const res = await requestSearchCddJobOverview({params: {cdd_id: cddId}})
        setOverviews(res.content)
    }

    useEffect(() => {
        (async () => {
            await fetchOverview(cddId);
        })();
    },[cddId])

    return (
        <>
            <Modal show={isShow}
                   size={"xl"}
                   onHide={onClose}
                   animation={false} style={{zIndex: 3002}}>
                <Modal.Header>
                    <Modal.Title>Overview</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {overviews.map((overview, index) => (
                        <DVTJCUVSearchCddJobOverviewContent overview={overview}/>
                    ))}
                </Modal.Body>
            </Modal>
        </>
)
}

export default DVTJCUVSearchCddJobOverviewModal;
